var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinTails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "445.7 -2.7 528.4 571.7",
    enableBackground: "new 445.7 -2.7 528.4 571.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C1272D",
    strokeMiterlimit: 10,
    d: "M608.6,624.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FED477",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    d: "M597.2,456.9c-9-2.7-20.8-6.8-34.1-12.7 c-9.6-4.3-20.3-8.9-33.3-17.4c-7.9-5.1-21.7-14.8-35.7-29.6c-9.8-10.4-14.1-17.4-15.3-19.2c-5-8.2-7.6-15.3-10.1-22.4 c-0.7-2.2-4.9-13.8-7.6-28.3c-9.5-49.6-5.5-88.7-5.5-88.7c6.7-66.9,39.2-114.7,46.1-124.4C547,50.1,607.8,26,622.4,20.7 c79.2-29.2,147.7-9,166.6-2.8c14.7,4.9,76.9,26.9,124.5,90.6c0,0,53.1,71,52.2,156.8c-0.1,11.7-1.6,32.8-6.4,57 c-4.3,20.9-6.5,32.1-13.5,45.7c-12.8,25.2-31.7,39.3-47.8,51.5c-4.2,3.1-23.2,17.2-51.8,28.6c-9.4,3.7-17.5,6.3-23.7,8.1 C818,466.1,601.9,467.1,597.2,456.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED477",
    stroke: "#FED477",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    d: "M694.7,464.1v36.3c0,29.3-20.7,56.8-49.9,56.8 h-0.2c-2.2-1-5.3-1.5-9-2.1c-7.3-1-12.9-3.6-17.9-5.6c-17.8-6.9-31.5-15.6-31.5-15.6c-25.3-15.3-42.3-32-45.7-35.6 c-15.6-15.4-26.9-31-35-44.1c-4.5-6.5-10.1-15.4-15.8-26.1c-7.2-13.5-15.5-31.5-22.1-52.9c-8.1-26.1-10.9-47.5-12-57.2 c-3.3-31.6-0.9-58.8-0.4-58.8c0.2,0-0.3,9.8,0.7,25.1c1.4,20.2,4.6,36,6.4,44.7c4.5,19.8,7,30.9,14,43.9 c7.8,14.4,16.8,23.2,26.5,32.4c0,0,38.2,36.5,94.4,51.5c5.5,1.5,10.5,2.5,10.9,2.6c15.1,3.1,25.6,3.7,49.5,4.2 C671.8,463.9,684.3,464.1,694.7,464.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED477",
    stroke: "#FED477",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    d: "M755,463.7c23.9-0.4,36.2-1,51.2-4.2 c4.6-0.9,8.2-1.8,11.2-2.6c12.5-3.2,43.8-12.4,73.9-33.1c2.8-1.9,5.2-3.5,6.3-4.4c8.3-6.1,18.9-13.8,29.1-24.9 c2.5-2.7,7.1-7.7,11.7-14.6c9.6-14.1,13.2-26.8,17.5-42.1c0,0,5.8-21.2,8.1-46.8c0.3-3,0.8-10.5,1.4-19.2c0.2-4.6,0.6-12,0.5-12 c-0.2,0-0.2,28.7-4.7,60.6c-2.7,19-7.3,49.9-23.1,85.8c-9.4,21.1-19.5,37.2-27,47.8c-5.7,8.6-13.7,19.5-24.4,31.2 c-18.8,20.5-36.2,32.7-46.8,40c0,0-21.5,14.9-44.7,24.1c-7.6,3-13.5,5.3-15.8,5.7c-3.7,0.5-6.9,1-9,2.1h-0.2 c-29.3,0-54.6-27.4-54.6-56.8v-36.3C726.9,464.1,740.6,463.9,755,463.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FED477",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    d: "M643.5,184.6c-2.1,91.6,131,91.6,127.9,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinTails);
export default __webpack_public_path__ + "static/media/coin-tails.0824513f119b4557514462ee245a4f38.svg";
export { ForwardRef as ReactComponent };